export const ImageCropTypes = {
  FREE_RATIO: 1,
  FIXED_RATIO: 2,
  COPY_FROM_SOURCE: 3,
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  FULLHEADLINE: 'fullHeadline',
};

export const ImageCropperTestIds = {
  BUTTON_IMAGE_CROPPER_PREV: 'image-cropper-prev-button',
  BUTTON_IMAGE_CROPPER_NEXT: 'image-cropper-next-button',
  BUTTON_IMAGE_CROPPER_FINISH: 'image-cropper-finish-button',
};
